import { render, staticRenderFns } from "./ElFieldCheckbox.vue?vue&type=template&id=4345f717"
import script from "./ElFieldCheckbox.vue?vue&type=script&lang=js"
export * from "./ElFieldCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports